import React, { useEffect, useState } from "react";
import axios from "axios";
import BreadCrumb from "../components/BreadCrumb";

const Terms = () => {
  const [termData, setTermData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get("https://app.endorselearning.co.uk/api/cms/3")
      .then(response => {
        setTermData(response.data.data);
        setLoading(false);
      })
      .catch(error => {
        console.error("Error fetching about data:", error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <p>Loading...</p>;
  }

  if (!termData) {
    return <p>Error loading content.</p>;
  }

  return (
    <>
      <BreadCrumb />
      <section className="section-space">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div dangerouslySetInnerHTML={{ __html: termData.description }} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Terms;
